import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function NavBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="w-full border-b border-[color:var(--line)] bg-white/80 backdrop-blur supports-[backdrop-filter]:bg-white/60 sticky top-0 z-30">
      <div className="max-w-6xl mx-auto px-5 py-3 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2"
          data-testid="nav-logo"
        >
          <span className="relative inline-block w-7 h-7">
            <span className="absolute inset-0 rounded-full bg-[color:var(--participant-a)]/60" />
            <span className="absolute inset-0 translate-x-2 rounded-full bg-[color:var(--participant-b)]/60 mix-blend-multiply" />
          </span>
          <span className="font-serif text-xl tracking-tight text-[color:var(--text-primary)]">
            FairResolver
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-6 text-sm">
          <NavLink to="/" end className="text-[color:var(--text-muted)] hover:text-[color:var(--text-primary)]" data-testid="nav-home">
            Home
          </NavLink>
          <NavLink to="/pricing" className="text-[color:var(--text-muted)] hover:text-[color:var(--text-primary)]" data-testid="nav-pricing">
            Pricing
          </NavLink>
          {user && (
            <NavLink to="/dashboard" className="text-[color:var(--text-muted)] hover:text-[color:var(--text-primary)]" data-testid="nav-dashboard">
              Dashboard
            </NavLink>
          )}
          {user?.role === "admin" && (
            <NavLink to="/admin" className="text-[color:var(--text-muted)] hover:text-[color:var(--text-primary)]" data-testid="nav-admin">
              Admin
            </NavLink>
          )}
        </nav>
        <div className="flex items-center gap-2">
          {user ? (
            <>
              <span className="hidden sm:inline text-sm text-[color:var(--text-muted)]" data-testid="nav-user-email">
                {user.email}
              </span>
              <button
                onClick={handleLogout}
                className="px-3 py-1.5 rounded-full text-sm font-medium border border-[color:var(--line)] bg-white hover:bg-[color:var(--surface-sage)] transition"
                data-testid="nav-logout"
              >
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="px-3 py-1.5 rounded-full text-sm font-medium text-[color:var(--text-primary)] hover:bg-[color:var(--surface-sage)]"
                data-testid="nav-login"
              >
                Sign in
              </Link>
              <Link
                to="/register"
                className="px-4 py-1.5 rounded-full text-sm font-semibold text-white bg-[color:var(--participant-a)] hover:opacity-90 transition"
                data-testid="nav-register"
              >
                Get started
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
